module.exports = __webpack_public_path__ + "img/call.45c6063e.svg";